 <div class="celleditor">
 <input
  #cellInput
  [(ngModel)]="value"
  class="ag-input w-100"
  (keydown)="onKeyDown($event)"
/>
 </div>